/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-bids-view-component',
  template: `
    <div *ngFor="let obj of objs">
      <small>{{ obj.label }}: </small><span>{{ obj.val | displayStat }}</span>
    </div>
    <div *ngIf="lineItem?.type === 'SPONSORSHIP'">SoV: {{ lineItem.sponsorshipPercentage }}%</div>
  `
})
export class BidsViewComponent implements OnInit, OnChanges {
  @Input() lineItem: any;

  objs: Array<{label: string; val: any}> = [];

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  ngOnChanges(): void {
    this.refresh();
  }

  private refresh(): void {
    if (!this.lineItem) {
      this.objs = [];
      return;
    }

    this.objs = _.compact(_.map(_.cloneDeep(this.lineItem.bidSpecification || {}), (val: any, key: string) => {
      if (!val || _.isEmpty(val)) {
        return;
      }
      if (key === 'cpm' || key === 'cpc') {
        const transKey = 'lineItem.bid.' + key;
        const trans = this.LocalNetworkProfile.getNetworkTranslations(transKey);
        return {label: trans || this.translate.instant(transKey), val};
      }
    }));
  }
}
